import { render, staticRenderFns } from "./CoozzyHomeIcon.vue?vue&type=template&id=4eb7b337&scoped=true"
import script from "./CoozzyHomeIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyHomeIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyHomeIcon.vue?vue&type=style&index=0&id=4eb7b337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb7b337",
  null
  
)

export default component.exports